export default "__VITE_ASSET__CR44TIc$__"